import React from "react";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";

const Sidebar = ({ setPageTitle, isOpen, onToggle, onClose, isMobile }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();

  const user = JSON.parse(localStorage.getItem("user") || "{}"); // fallback للـ JSON.parse

  const navigationItems = [
    {
      label: "dashboard",
      path: "/admin-dashboard",
      icon: "/images/img_mingcute_home_4_fill.svg",
      badge: null,
      tooltip: t("overviewTooltip") || "Overview",
    },
    {
      label: "orders",
      path: "/order-management",
      icon: "/images/img_cart.svg",
      tooltip: t("orderProcessingTooltip") || "Order Processing",
    },
    {
      label: "notifications",
      path: "/notifications",
      icon: "/images/img_bell_outline.svg",
      tooltip: t("notifications") || "Notifications",
    },
   
    {
      label: "معلومات الشحن",
      path: "/shipping-setting",
      icon: "/images/img_famicons_card_outline.svg",
      badge: null,
      tooltip: null,
    },
    {
      label: "المحافظات",
      path: "/governorates-management",
      icon: "/images/img_ticket.svg",
      badge: null,
      tooltip: null,
    },
    {
      label: "categories",
      path: "/category-management",
      icon: "/images/img_circle_square.svg",
      badge: null,
      tooltip: t("organizeCategoriesTooltip") || "Organize Categories",
    },
    {
      label: "add_product",
      path: "/add-product",
      icon: "/images/img_circle_plus.svg",
      badge: null,
      tooltip: null,
    },
    {
      label: "product_list",
      path: "/product-catalog-management",
      icon: "/images/img_fluent_mdl2_product_list.svg",
      badge: null,
      tooltip: null,
    },
       {
      label: "عروضات وخصومات",
      path: "/discounted-product-catalog-management",
      icon: "/images/img_fluent_mdl2_product_list.svg",
      badge: null,
      tooltip: null,
    },
    {
      label: "advertisement_management",
      path: "/advertisement-management",
      icon: "/images/img_search.svg",
      badge: null,
      tooltip: null,
    },
        {
      label: "سلايدر رئيسي",
      path: "/second-advertisement-management",
      icon: "/images/img_search.svg",
      badge: null,
      tooltip: null,
    },
     {
      label: "customers",
      path: "/customer-management",
      icon: "/images/img_users.svg",
      badge: null,
      tooltip: t("manageCustomersTooltip") || "Manage Customers",
    },
    {
      label: "admins",
      path: "/admins-management",
      icon: "/images/img_users.svg",
      badge: null,
      tooltip: t("manageCustomersTooltip") || "Manage Admins",
    },
    {
      label: "coupon_management",
      path: "/coupon-management",
      icon: "/images/img_ticket.svg",
      badge: null,
      tooltip: null,
    },
  ];

  const handleNavigation = (path, label) => {
    navigate(path);
    setPageTitle(label);
    if (isMobile) onClose(); // إغلاق الـ Sidebar على الموبايل بعد التنقل
  };

  const isActiveRoute = (path) => location.pathname === path;

  // لو مش مفتوح، مش نعرض الـ Sidebar على الموبايل
  if (isMobile && !isOpen) return null;

  return (
    <aside
      className={`fixed inset-y-0 left-0 z-50 w-full lg:w-auto h-full bg-white shadow-[0px_3px_4px_#0000001e] lg:shadow-lg pt-5 overflow-y-auto transition-transform duration-300 ease-in-out lg:static lg:inset-auto lg:translate-x-0 ${
        isOpen ? "translate-x-0" : "-translate-x-full"
      } lg:w-[20%] ${isMobile ? "w-full" : ""}`} // عرض كامل على موبايل، 18% على ديسكتوب
      aria-label="Main navigation"
    >
      {/* Header مع Close Button */}
      <div className="flex justify-center items-center w-full px-5 mb-7 sticky top-0 bg-white z-10 py-1 border-b border-gray-200">
        <img
          src="/images/img_sidebar_logo.png"
          alt={t("logo") || "Logo"}
          className="w-[180px] h-[100px]"
        />
        {/* Close Button - يظهر على الموبايل، ويستخدم onClose */}
        <button
          onClick={onClose || onToggle} // استخدم onClose لو موجود، وإلا onToggle
          className="w-6 h-6 cursor-pointer hover:opacity-80 lg:hidden" // مخفي على ديسكتوب
          aria-label={t("close_menu") || "Close sidebar"}
        >
          <img
            src="/images/img_material_symbol.svg"
            alt="Close icon"
            className="w-6 h-6"
          />
        </button>
      </div>

      {/* Main Menu Section */}
      <div className="px-6 mb-4">
        <span className="text-[15px] font-normal text-[#6a717f]">
          {t("main_menu") || "Main Menu"}
        </span>
      </div>

      {/* Navigation Items */}
      <div className="flex flex-col items-center w-full px-2 flex-1">
        {navigationItems.map(({ label, path, icon, badge, tooltip }, index) => {
          const active = isActiveRoute(path);
          return (
            <div
              key={index}
              onClick={() => handleNavigation(path, label)}
              className={`flex justify-start items-center w-full p-3 mb-3 rounded-md cursor-pointer transition-colors ${
                active ? "bg-[#a1cf52]" : "hover:bg-gray-50"
              }`}
              title={tooltip || label}
              role="button"
              tabIndex={0}
              onKeyDown={(e) =>
                e.key === "Enter" && handleNavigation(path, label)
              }
            >
              <img
                src={icon}
                // alt={`${label} icon`}
                className={`w-[22px] h-[22px] ml-2 flex-shrink-0 ${
                  active ? "filter brightness-0 invert" : ""
                }`}
              />
              <span
                className={`text-base ml-2 flex-1 min-w-0 truncate ${
                  active
                    ? "font-bold text-white"
                    : "text-[#6a717f] hover:text-black"
                }`}
              >
                {t(label)}
              </span>
              {badge && (
                <span className="ml-auto bg-red-500 text-white text-xs rounded-full px-2 py-1 min-w-[20px] text-center">
                  {badge}
                </span>
              )}
            </div>
          );
        })}

        {/* User Profile Section - في الأسفل */}
        <div className="flex justify-start items-center w-full bg-white rounded-lg p-2.5 mb-3 mx-2 mt-auto">
          <div className="flex gap-3 justify-start items-center w-full ml-1.5">
            <img
              src="/images/img_17_picture.png"
              alt="User  Avatar"
              className="w-10 h-10 rounded-full flex-shrink-0"
            />
            <div className="flex flex-col justify-start items-start flex-1 min-w-0">
              <span className="text-sm text-[#737373] truncate">
                {user?.account || t("user") || "User "}
              </span>
            </div>
          </div>
          <button
            onClick={() => {
              localStorage.clear();
              navigate("/login"); // استخدم navigate بدل window.location
            }}
            className="w-5 h-5 mr-2 cursor-pointer hover:opacity-80 flex-shrink-0"
            aria-label={t("logout") || "Logout"}
          >
            <img src="/images/img_ic_round_logout.svg" alt="Logout icon" />
          </button>
        </div>
      </div>
    </aside>
  );
};

export default Sidebar;
